import Component from '../abstracts/Component';
import { doAjax } from '../utils/ajaxUtil';

export default class WishlistLogic extends Component {

  get CLASSES() {
    return {
      iconWishlistOff: "icon-wishlist-off",
      iconWishlistOn: "icon-wishlist-on",
    };
  }

  constructor() {
    super();
  }

  async addToWishlist(url,productCode) {
    const response = await fetch(url+"?code="+productCode);
    if (response.ok) {
      return response;
    }
    return null;
  }

  async removeFromWishlist(url, productCode) {
    const response = await fetch(url+productCode, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      return response;
    }
    return null;
  }

  wishlistCheckAjax(productCode) {
    return new Promise( (resolve, reject) => {
      let data = {};
      data[productCode] = productCode;
      const contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context");
      $.ajax({
        url: contextPath + "/action/ajax/wishlist-check-product",
        data: {
          code: productCode
        },
        success: function (result) {
          resolve(result);
        }
      });
    });
  }

  updateWishlistIcon(icon, isEmpty=true) {
    if(isEmpty) {
      icon.classList.remove(this.CLASSES.iconWishlistOn);
      icon.classList.add(this.CLASSES.iconWishlistOff);
    } else {
      icon.classList.add(this.CLASSES.iconWishlistOn);
      icon.classList.remove(this.CLASSES.iconWishlistOff);
    }
  }

  updatePDPButton(button, isInWishlist = true, isPdpButton = false) {
    if (isInWishlist) {
      const btnMessage = button.querySelector(".custom-button__message");
      btnMessage ? btnMessage.innerHTML = button.dataset.confirmMessage : '';
      if (isPdpButton) button.dataset.pdpWishlistButton = true;
      else button.dataset.wishlistBtn = true;
      button.classList.add(this.CLASSES.iconWishlistOn);
      button.classList.remove(this.CLASSES.iconWishlistOff);
    } else {
      const btnMessage = button.querySelector(".custom-button__message");
      btnMessage ? btnMessage.innerHTML = button.dataset.addMessage : '';
      if (isPdpButton) button.dataset.pdpWishlistButton = false;
      else button.dataset.wishlistBtn = false;
      button.classList.add(this.CLASSES.iconWishlistOff);
      button.classList.remove(this.CLASSES.iconWishlistOn);
    }
  }

  render() {}
}
